<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
// eslint-disable-next-line
import styles from '@/assets/main.scss';

export default {
  name: 'app',
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// App.vue?47fdd7a7